module.exports = __webpack_public_path__ + "img/princeton-logo.a788916b.png";